import React from 'react';
import { ReactComponent as CalendarIcon } from 'assets/icons/ui-elements/small/calendar-sm.svg';
import { ReactComponent as PrevIcon } from 'assets/icons/navigation/small/chevron-left-sm.svg';
import { ReactComponent as NextIcon } from 'assets/icons/navigation/small/chevron-right-sm.svg';
import { ReactComponent as FilterOn } from 'assets/icons/ui-elements/small/filter-on-sm.svg';
import { ReactComponent as FilterOff } from 'assets/icons/ui-elements/small/filter-off-sm.svg';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
import { SelectDropdown } from 'newComponents/Form/Select';
import {
  CalendarToolBar,
  ViewsButtonsContainer,
  ToolBarFirstRow,
  NavigateCalendarButtonsContainer,
  NavigationContainer,
  TipoboxWrapper,
  Tipobox,
  TipoboxText,
  FiltersButtonContainer,
  FiltersButton,
  TodayButton,
  PrevNextButton,
  MonthYearContainer,
} from '../styled';
import { ReactComponent as BullhornIcon } from 'assets/icons/bullhorn_sm.svg';
import { formatWeekRange, formatDayLabel, formatMonthLabel } from '../../../utils/dateFormatters';
import { CalendarView } from '../../../hooks/useCalendarNavigation';

interface CalendarToolbarProps {
  currentDate: Date;
  view: number;
  viewsOptions: Array<{ label: string; value: number }>;
  onViewChange: (value: string | number | null) => void;
  onNavigate: (direction: 'prev' | 'next') => void;
  onGoToToday: () => void;
  openFilters: boolean;
  onToggleFilters: () => void;
  filtersButtonLabel: string;
  showClearFilters: boolean;
  onClearFilters: () => void;
}

export const CalendarToolbar: React.FC<CalendarToolbarProps> = ({
  currentDate,
  view,
  viewsOptions,
  onViewChange,
  onNavigate,
  onGoToToday,
  openFilters,
  onToggleFilters,
  filtersButtonLabel,
  showClearFilters,
  onClearFilters,
}) => {
  return (
    <CalendarToolBar>
      <ToolBarFirstRow>
        <ViewsButtonsContainer>
          <TodayButton onClick={onGoToToday}>Hoje</TodayButton>
          <SelectDropdown
            options={viewsOptions}
            value={view}
            onChange={onViewChange}
            searchable={false}
            clearable={false}
            size="sm"
            width="118px"
            iconLeft={<CalendarIcon />}
          />
          <NavigateCalendarButtonsContainer>
            <NavigationContainer>
              <PrevNextButton onClick={() => onNavigate('prev')}>
                <PrevIcon />
              </PrevNextButton>
              <PrevNextButton onClick={() => onNavigate('next')}>
                <NextIcon />
              </PrevNextButton>
              <MonthYearContainer>
                {view === CalendarView.Dia
                  ? formatDayLabel(currentDate)
                  : view === CalendarView.Mes
                  ? formatMonthLabel(currentDate)
                  : formatWeekRange(currentDate)}
              </MonthYearContainer>
            </NavigationContainer>
          </NavigateCalendarButtonsContainer>
          <TipoboxWrapper>
            <Tipobox>
              <BullhornIcon />
              <TipoboxText>
                <strong>Em breve:</strong> Novas funcionalidades na agenda.
              </TipoboxText>
            </Tipobox>
          </TipoboxWrapper>
          <FiltersButtonContainer>
            <FiltersButton onClick={onToggleFilters}>
              {openFilters ? <FilterOff /> : <FilterOn />} {filtersButtonLabel}
            </FiltersButton>
            {showClearFilters && (
              <FiltersButton onClick={onClearFilters}>
                <XIcon />
                Limpar Filtros
              </FiltersButton>
            )}
          </FiltersButtonContainer>
        </ViewsButtonsContainer>
      </ToolBarFirstRow>
    </CalendarToolBar>
  );
};
